import AgencyPortal from './components/AgencyPortal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';

import {
  updateUser,
  loadImpersonatedUser,
  loadActiveUser,
  loadAgency,
  loadCampaignsForAgency,
  loadUsersForAgency,
  loadBrandsForAgency,
  loadPaymentMethodsForAgency,
  loadAgencyWithChildren
} from '../../shared/redux/entities/actions';

import {
  requestImpersonateTokenWithCredentials,
  invalidateImpersonateToken
} from '../../shared/redux/impersonate/actions';

import {
  showNotification,
  dismissNotification
} from '../../shared/redux/notifications/actions';

import { loadKPIsForAgency } from '../../shared/redux/kpis/actions';
import { invalidateAuthToken } from '../../shared/redux/auth/actions';

import {
  startIntro,
  advanceIntro,
  completeIntro
} from '../../shared/redux/intro/actions';

import './assets/AgencyPortal.css';

import { getActiveAgencyUser } from '../../shared/redux/selectors';

function mapStateToProps(state,props){
  const user = getActiveAgencyUser(state);

  return {
    environment:state.version.environment,
    frontEndVersion:state.version.frontend,
    backEndVersion:state.version.backend,    
    pathname:props.location.pathname,
    isImpersonating:!!(props.match.params && props.match.params.email),
    impersonatingEmail:props.match.params.email,
    isLoggedIn:get(state,['auth','token']) !== null,
    hasSeenIntro:user.hasCompletedIntroduction,
    user:user,
    agency:get(state,['entities','agencies',user.agencyId]),
    notifications:state.notifications,
    shouldForceOpenProfileMenu:state.intro.currentStep === 3
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadPaymentMethodsForAgency,
    requestImpersonateTokenWithCredentials,
    loadImpersonatedUser,
    loadActiveUser,
    loadUsersForAgency,
    loadBrandsForAgency,
    loadCampaignsForAgency,
    loadKPIsForAgency,
    loadAgency,
    loadAgencyWithChildren,
    invalidateImpersonateToken,
    invalidateAuthToken,
    showNotification,
    dismissNotification,
    startIntro,
    advanceIntro,
    completeIntro,
    updateUser
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AgencyPortal));



// WEBPACK FOOTER //
// ./src/routes/AgencyPortal/index.js